/**
 * Simple script to check and log the number of products in the user's wishlist
 * Runs on page load and logs the wishlist count to console
 * Also updates count dynamically when products are added/removed
 */
let currentWishlistCount = 0;
function getHandleFromProductUrl(url) {
  if (!url) return null;
  const parts = String(url).split('/products/');
  if (parts.length < 2) return null;
  return parts[1].split('?')[0].replace(/\/$/, '');
}
function updateCountFromListContents(listContents) {
  const contents = Array.isArray(listContents) ? listContents : [];
  if (!contents.length) {
    currentWishlistCount = 0;
    window.dispatchEvent(new CustomEvent('wishlist:count-updated', {
      detail: {
        count: currentWishlistCount
      }
    }));
    return;
  }

  // Filter out unavailable products by checking their card endpoint response
  const checks = contents.map(function (item) {
    const handle = getHandleFromProductUrl(item.du);
    if (!handle) return Promise.resolve(false);
    const viewUrl = '/products/' + handle + '?view=card';
    return fetch(viewUrl, {
      credentials: 'same-origin'
    }).then(function (res) {
      return res.ok;
    }).catch(function () {
      return false;
    });
  });
  Promise.all(checks).then(function (results) {
    // Count only those with res.ok === true
    currentWishlistCount = results.reduce(function (acc, ok) {
      return acc + (ok ? 1 : 0);
    }, 0);
    window.dispatchEvent(new CustomEvent('wishlist:count-updated', {
      detail: {
        count: currentWishlistCount
      }
    }));
  }).catch(function () {
    currentWishlistCount = 0;
    window.dispatchEvent(new CustomEvent('wishlist:count-updated', {
      detail: {
        count: currentWishlistCount
      }
    }));
  });
}
function applyBootstrapData(data) {
  if (!data) return;
  updateCountFromListContents(data.listContents);
}

// Re-fetch the wishlist to get the updated count
function updateWishlistCount() {
  if (typeof window.refreshSwymWishlist === 'function') {
    window.refreshSwymWishlist().then(applyBootstrapData).catch(function (error) {
    });
    return;
  }
  if (window.__swymData) {
    applyBootstrapData(window.__swymData);
  }
}

// Function to initialize the wishlist count check
function initWishlistCountCheck() {
  if (window.__swymData) {
    applyBootstrapData(window.__swymData);
  } else {
    window.addEventListener('swym:bootstrapped', function (event) {
      applyBootstrapData(event.detail);
    }, {
      once: true
    });
  }

  // Listen for wishlist changes from PDP and PLP
  window.addEventListener('wishlist:product-added', function () {
    // Add a small delay to ensure the wishlist has been updated on the server
    setTimeout(updateWishlistCount, 500);
  });
  window.addEventListener('wishlist:product-removed', function () {
    // Add a small delay to ensure the wishlist has been updated on the server
    setTimeout(updateWishlistCount, 500);
  });
}

// Custom element for wishlist count display
class WishlistCount extends HTMLElement {
  connectedCallback() {
    // Listen for wishlist count updates
    window.addEventListener('wishlist:count-updated', event => {
      const count = event.detail.count;
      this.innerText = count;

      // Show/hide based on count
      if (count > 0) {
        this.style.display = 'inline-flex';
      } else {
        this.style.display = 'none';
      }
    });

    // Set initial count and hide
    this.innerText = '0';
    this.style.display = 'none';
  }
}

// Register the custom element
if (!customElements.get('wishlist-count')) {
  customElements.define('wishlist-count', WishlistCount);
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWishlistCountCheck);
} else {
  initWishlistCountCheck();
}
